class buttonUp extends HTMLElement {
  constructor() {
    super();
    
    this.buttonUp = this.querySelector('.button-up');
    this.currentScrollTop = 0;

    // Init component
    this.init();
  }
  /**
  * Init component
  */
  init() {
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.buttonUp.addEventListener('click', this.scrollToTop.bind(this));
  }

  /**
  * On scroll
  */
  onScroll(e) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 100) {
      requestAnimationFrame(this.show.bind(this));
    } else {
      requestAnimationFrame(this.hide.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    document.body.classList.remove('show-scroll-to-top');
  }

  show() {
    document.body.classList.add('show-scroll-to-top');
  }

  /**
  * Scroll to top
  */
  scrollToTop(e) {
    e.preventDefault();

    // Scroll to the targetElement
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}

if (!customElements.get('button-up')) {
  customElements.define('button-up', buttonUp);
}